import React from 'react';
import MySpinner from './MySpinner';
import theme from '../theme/theme';

const LoadingSpinnerComponent =({spinnerColor = theme.colors.primary})=>{
return (
    <div className="d-flex flex-column align-items-center">
<span>جار التحميل...</span>
<MySpinner  color={spinnerColor} />
</div>
);

}

export default LoadingSpinnerComponent;